export default "__VITE_ASSET__6d31d9fb__"